import { getQueryStrinngFromObject, getRequestData } from '../../Utility/apiHelper';
import * as actionTypes from './type';

export const handleRequestAuditLogs = () => () => {

} 

export const handleRequestSearchAuditLogs = (payload) => async(dispatch) => {

    try {


        dispatch({
            type: actionTypes.REQUEST_AUDIT_LOGS,
            payload
        })
        const queryparam = getQueryStrinngFromObject(payload);

        const response = await getRequestData(
            `audit/fetchlogs?${queryparam}`
        );

        const { data } = response;

        const mappedData = data?.map(item => {
          return {
            ...item,
            key: item?.id
          }
        }).sort((a,b) => new Date(b?.createdAt) - new Date(a?.createdAt));

        dispatch({
            type: actionTypes.RECEIVED_AUDIT_LOGS,
            payload: mappedData
        })
        

    } catch(error) {

        dispatch({
            type: actionTypes.ERROR_AUDIT_LOGS
        })
        
    }
}
